// extracted by mini-css-extract-plugin
export default {"menu":"useActivityRepeatMenu_menu__Y1thE"};